<template>
  <div v-if="loaded">
    <Mail
      :emails_list="mandat.emails"
      :attached_objects="[
        {
         object: 'NoteCloture',
         id: mandat_id
        }
      ]"
      :body="body"
      :subject="subject"
      @close="$emit('close', $event)"
    >
    </Mail>
  </div>
</template>

<script>
import documents from "@/services/documents";
import Mail from "@/components/Mail.vue";
export default {
  name: "NoteClotureMail",
  components: {
    Mail,
  },
  props: {
    mandat_id: [Number, String],
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mandat: {},
      body: `Cabinet De Greft

Rue Chantraine 158/021
B-4420 SAINT-NICOLAS

TEL.: 0032 4 254 05 50
FAX: 0032 4 252 22 13
TVA : BE0478434880
IBAN: BE43 3630 4182 2501
BIC: BBRUBEBB`,
      loaded: false,
      subject: ''
    };
  },
  created() {
    this.load();
  },
  methods: {
      load() {
      documents
        .get_single('mandat_nc', this.$props.mandat_id)
        .then((response) => {
          this.mandat = response.data;
          this.body = this.mandat.body + "\n" + this.body;
          this.subject = this.mandat.subject;
          this.loaded = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>